import { defineStore } from "pinia";
import { ref } from "vue";

export interface CurrentUser {
  id: string;
  username: string;
  role: "user" | "staff" | "admin";
}

export const useAuthStore = defineStore("auth", () => {
  const user = ref<CurrentUser | null>(null);
  const loaded = ref(false);

  async function refresh() {
    try {
      const res = await fetch("/api/auth/me", { credentials: "include" });
      const data = (await res.json()) as { user: CurrentUser | null };
      user.value = data.user;
    } catch {
      user.value = null;
    } finally {
      loaded.value = true;
    }
  }

  async function logout() {
    await fetch("/api/auth/logout", {
      method: "POST",
      credentials: "include",
    });
    user.value = null;
  }

  return { user, loaded, refresh, logout };
});
